import React, { useState } from 'react';
import '../../Themes/styles.css';
//MUI
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
//Selfmade
import Copyright from './copyright';

//Icons
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';

//React router dom
import { useNavigate, Link } from 'react-router-dom';

import mainURL from '../../config/environment';
import $ from 'jquery';

//Assets
import backgroundImg from '../../assets/BackgroundNight.jpg';
import { styled } from '@mui/material/styles';
// import { Button, OutlinedInput, Typography } from "@mui/material";
// import { styled } from '@mui/material/styles';

const styles = {
  backgroundImg: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  passwordInput: {
    backgroundColor: '#E4E4E4',
    borderRadius: '4px',
    opacity: '70%',
    fontWeight: '600',
    paddingLeft: 2,
    paddingRight: 2,
    height: '2.7rem',
    border: '2px',
    borderColor: 'red',
  },
  boxCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxContainer: {
    height: '90%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imgBoxContainer: {
    maxWidth: '32rem',
    width: '90%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '30px',
    padding: '2rem',
    '@media (max-width: 768px)': {
      padding: '1.5rem',
      maxWidth: '28rem',
    },
    '@media (max-width: 480px)': {
      padding: '1rem',
      maxWidth: '24rem',
    },
  },
  titleBoxContainer: {
    mt: 3,
    textAlign: 'center',
  },
};
const ButtonCss = styled(Button)`
  background: #44c554;
  font-weight: bold;
  text-transform: unset;
  font-size: 16px;
  color: white;
  &:hover,
  &:disabled {
    background: #205b25;
  }
  &:focus {
    background: #3db449;
  }
  &:active {
    background: #3db449;
  }
`;

export default function Login() {
  const navigate = useNavigate();
  //Load management
  const [isLoading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  //Notification management
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({
    severity: '',
    message: '',
  });

  const handleShowNotification = (severity, message) => {
    setNotificationMessage({ severity: severity, message: message });
    setShowNotification(true);
    setTimeout(function () {
      setShowNotification(false);
    }, 3000);
  };

  //Data management
  const [model, setModel] = useState({
    email: '',
    password: '',
  });

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setModel({
      ...model,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    $.ajax({
      method: 'POST',
      url: mainURL + 'login/authenticate-user',
      contentType: 'application/json',
      data: JSON.stringify(model),
    })
      .done((res) => {
        setLoading(false);
        localStorage.setItem('userInfo', JSON.stringify(res));
        navigate('/');
      })
      .fail((res) => {
        setLoading(false);
        if (res.status === 401) {
          handleShowNotification('error', 'Invalid email or password');
        }
      });
  };

  return (
    <Box
      component="main"
      style={styles.backgroundImg}
      sx={{
        height: '100vh',
        width: '100vw',
        padding: '1rem 2rem',
      }}
    >
      <CssBaseline />

      <Box sx={{ ...styles.boxContainer, ...styles.boxCenter, paddingTop: '3rem' }}>
        <Box sx={{ ...styles.imgBoxContainer, ...styles.boxCenter }}>
          <img
            src="assets/images/Americas-Logo.png"
            alt="Logo"
            style={{
              height: 'auto',
              maxWidth: '16rem',
              width: '100%',
              '@media (max-width: 768px)': {
                maxWidth: '12rem',
              },
              '@media (max-width: 480px)': {
                maxWidth: '8rem',
              },
            }}
          />

          <Box sx={{ ...styles.titleBoxContainer, ...styles.boxCenter }}>
            <Typography
              variant="h2"
              sx={{
                color: 'white',
                fontWeight: '700',
                fontSize: '50px',
                '@media (max-width: 768px)': {
                  fontSize: '35px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '28px',
                },
              }}
            >
              {'Welcome!'}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontWeight: '500',
                fontSize: '16px',
                '@media (max-width: 768px)': {
                  fontSize: '14px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '12px',
                },
              }}
            >
              {
                'Log in to your personalized dashboard and stay up to date with progress, deliverables, and key milestones.'
              }
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 5, width: '100%' }}>
            <FormControl fullWidth>
              <Typography sx={{ color: 'white', fontSize: '16px', mb: '0.5rem' }}>
                {'Email'}
              </Typography>

              <Input
                sx={styles.passwordInput}
                margin="dense"
                required
                name="email"
                type={'text'}
                id="email"
                autoComplete="email"
                onChange={handleChange}
              />
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
              <Typography sx={{ color: 'white', fontSize: '16px', mb: '0.5rem' }}>
                {'Password'}
              </Typography>

              <Input
                sx={styles.passwordInput}
                margin="dense"
                required
                name="password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            {isLoading ? (
              <Grid container justifyContent={'center'} sx={{ mt: 3, mb: 1 }}>
                <CircularProgress />
              </Grid>
            ) : showNotification ? (
              <Alert variant="filled" severity={notificationMessage.severity}>
                {notificationMessage.message}
              </Alert>
            ) : (
              <ButtonCss
                disabled={!model.email || !model.password}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 1 }}
              >
                Login
              </ButtonCss>
            )}
            {!isLoading ? (
              <Grid container justifyContent={'flex-end'}>
                <Grid item>
                  <Link
                    to="/forgot-password"
                    variant="body2"
                    style={{ color: 'white', fontSize: '16px', fontWeight: '500' }}
                  >
                    ¿Forgot Password?
                  </Link>
                </Grid>
              </Grid>
            ) : null}
            <Copyright sx={{ mt: 4 }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
